module.exports = __webpack_public_path__ + "img/inner-circle.aabb8a73.png";